export default "__VITE_PUBLIC_ASSET__1875534e__"